<div class="loader-overlay">
  <div class="spinner-wrapper">
    <mat-spinner [diameter]="30" color="accent"></mat-spinner>
    <span class="text">{{ text }}</span>
  </div>
</div>
